/**
 * Puppeteer browser used for PDF export so layout matches the client's
 * Paged.js preview engine (Chromium vs Gecko).
 */
export type PdfBrowserEngine = "chrome" | "firefox";

export const defaultPdfBrowserEngine: PdfBrowserEngine = "chrome";

const allowedPdfBrowserEngines = ["chrome", "firefox"] as const;

export function isPdfBrowserEngine(
  value: unknown,
): value is PdfBrowserEngine {
  return (
    typeof value === "string" &&
    (allowedPdfBrowserEngines as readonly string[]).includes(value)
  );
}

/**
 * Detect which Puppeteer engine should render the PDF so it matches the
 * live preview. Desktop Firefox (Gecko) → firefox; iOS Firefox (FxiOS /
 * WebKit) and everything else → chrome.
 */
export function detectPdfBrowserEngine(
  userAgent: string | null | undefined = typeof navigator !== "undefined"
    ? navigator.userAgent
    : undefined,
): PdfBrowserEngine {
  if (!userAgent) {
    return defaultPdfBrowserEngine;
  }

  // iOS Firefox is WebKit under the hood — Chromium PDF is the closer match.
  if (/FxiOS\//i.test(userAgent)) {
    return defaultPdfBrowserEngine;
  }

  if (/Firefox\//i.test(userAgent)) {
    return "firefox";
  }

  return defaultPdfBrowserEngine;
}
